<template>
  <!-- -->
  <div class="form-items" :class="`display-${columns}`" :style="{'--label-width': labelWidth, '--icon-width': iconWidth, '--status-color': statusColor}">
    <slot/>
    <div class="status" v-if="showStatus">
      <slot name="status"></slot>
    </div>
  </div>
</template>

<script>

import {watch} from "vue";

export default {
  props: {
    // 要验证的数据，数据校验时必须要填写，否则失效
    data: {default: () => {}},
    columns: {default: "3"},
    labelWidth: {default: "4rem"},
    iconWidth: {default: "1rem"},
    statusColor: {default: "#409eff"},
    showStatus: {default: false},
  },
  name: "",
  components: {
  },
  data() {
    return {
      children: []
    };
  },
  created() {

    watch(() => this.data, () => {
      this.validCheck();
    }, {deep: true})
  },
  mounted() {
    this.validCheck();
  },
  methods: {
    // 进行数据验证,返回true/false表示通过/拒绝
    validCheck() {
      // 通过FormItem获取slot里面的内容
      let res = true;
      for (let i = 0; i < this.children.length; i++) {
        if (!this.children[i].required) {
          this.children[i].hideErrorMessage();
          continue
        }
        if (!this.children[i].name) {
          this.children[i].hideErrorMessage();
          continue
        }
        // 这是必填项
        let data = this.data[this.children[i].name];
        if (data === null || data === undefined || data === "") {
          // 数据不存在，校验不通过
          this.children[i].showErrorMessage();
          res = false;
        } else {
          // 数据存在，验证数据
          if (this.checkData(data, this.data, this.children[i])) {
            // 验证通过
            this.children[i].hideErrorMessage();
          } else {
            this.children[i].showErrorMessage();
          }
        }
      }
      return res;
    },
    // 进行数据验证，验证通过为true
    checkData(data, dataObj, page) {
      if (page.maxLength && data.length > page.maxLength) {
        // 长度超标
        return false;
      }
      if (page.minLength && data.length < page.minLength) {
        // 长度不足
        return false;
      }
      if (page.max && data > page.max) {
        // 超出最大值
        return false;
      }
      if (page.min && data < page.min) {
        // 小于最小值
        return false;
      }
      if (page.pattern) {
        let res = new RegExp(page.pattern).test(data + "");
        if (!res) {
          return false;
        }
      }
      if (page.checkFunction) {
        let res = page.checkFunction(data, dataObj);
        if (!res) {
          return false;
        }
      }
      return true;
    },
    addFormItem(itemPage) {
      this.children.push(itemPage);
    },
    removeFormItem(itemPage) {
      this.children = this.children.filter(item => item !== itemPage);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-items{
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0 20px;
  box-sizing: border-box;
  .status{
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    color: var(--status-color);
    border-radius: 4px;
    padding: 5px 10px;
    border: 1px solid var(--status-color);
    opacity: .7;
    rotate: 315deg;
  }
}
// 一行1个元素
.display-1{
  :deep(.form-item) {
    width: 100%;
  }
}
.display-2{
  :deep(.form-item) {
    width: calc(50% - 10px);
    &.col-span-2{
      width: 100%;
    }
  }
}
.display-3{
  gap: 0 15px;
  :deep(.form-item) {
    width: calc(33% - 10px);
    &.col-span-2{
      width: 66%;
    }
    &.col-span-3{
      width: 100%;
    }
  }
}
.display-4{
  gap: 0 12px;
  :deep(.form-item) {
    width: calc(25% - 9px);
    &.col-span-2{
      width: 50%;
    }
    &.col-span-3{
      width: 75%;
    }
    &.col-span-4{
      width: 100%;
    }
  }
}
</style>